export const experienceLevels = [
  {
    level: 5,
    name: 'Lived there',
    color: 'bg-rose-500',
    textColor: 'text-rose-600',
    ringColor: 'ring-rose-500',
    fillColor: '#f43f5e'
  },
  {
    level: 4,
    name: 'Stayed there',
    color: 'bg-amber-500',
    textColor: 'text-amber-600',
    ringColor: 'ring-amber-500',
    fillColor: '#f59e0b'
  },
  {
    level: 3,
    name: 'Visited there',
    color: 'bg-yellow-400',
    textColor: 'text-yellow-600',
    ringColor: 'ring-yellow-400',
    fillColor: '#facc15'
  },
  {
    level: 2,
    name: 'Alighted there',
    color: 'bg-emerald-500',
    textColor: 'text-emerald-600',
    ringColor: 'ring-emerald-500',
    fillColor: '#10b981'
  },
  {
    level: 1,
    name: 'Passed there',
    color: 'bg-sky-400',
    textColor: 'text-sky-600',
    ringColor: 'ring-sky-400',
    fillColor: '#38bdf8'
  },
  {
    level: 0,
    name: 'Never been there',
    color: 'bg-white',
    textColor: 'text-gray-500',
    ringColor: 'ring-gray-300',
    fillColor: '#ffffff'
  }
];